<template>
    <div>
        <responsive-button :icon="['fas', !params.isAssign ? 'plus' : 'minus']" variant="default" @click="onClick">{{
            !params.isAssign ? 'Add ' + params.propertyName : 'Remove ' + params.propertyName }}</responsive-button>

    </div>
</template>

<script>
import responsiveButton from '../../generic/responsive-button/responsive-button.vue';
export default {
    components: {
        responsiveButton
    },
    name: 'AssignActionCellRenderer',
    methods: {
        onClick() {
            this.params.onClick(this.params.data)
        },

    },

}
</script>

<style scoped>
/* Your CSS code goes here */
</style>
